import { Container, Col } from 'reactstrap'
import styled from 'styled-components'

export const HoursDiv = styled(Container)`
    margin: 7rem auto 7rem auto;
    h3{
        margin-bottom: 2rem;
    }
    div{
        font-size: 120%;
    }
`
export const CaterDiv = styled.div`
    display: none;
    @media  screen and (min-width: ${({ theme }) => theme.breakpoints.medium}) { 
        display: block;
        background: #B88C6D;
        padding-top: 5rem;
        padding-bottom: 3rem;
    }
`
export const ImgContainer = styled(Col)`
    margin: auto;
    img{
        width: 90%;
    }
    @media  screen and (min-width: ${({ theme }) => theme.breakpoints.xlarge}) { 
        img{
            width: 80%;
        }
    }
`
export const Img =  styled.img`
    width: 90%;
`
export const CompanyDiv = styled.div`
    padding-top: 0.7rem;
    padding-bottom: 0.7rem;
    background: ${({ theme }) => theme.colors.mainBrown};
    color: white;
`